// Keys for sessionStorage.

export const SESSION_IDP_ENTITY_ID_KEY = 'idp_entity_id';
